module.exports = __webpack_public_path__ + "img/rule-btn2-act.8a40a765.png";